import React from 'react';
import '@resources/assets/styles/_header.scss';

function ProgressWithLabel({ value }) {
    return (
        <div className="progress-bar-container">
            {/* Progress Bar */}
            <div
                className="progress-bar-fill"
            >
                {
                    value > 0 &&
                    <span className="progress-bar-text">{`${value}%`}</span>
                }
            </div>
        </div>
    );
}

export default ProgressWithLabel;